/**
 * Historia 176 — RN16d (DC-21). Every history entry E is a STATE; its "Go back here" button puts back
 * `E.newValue`. `restore` (2.3) puts back the `previousValue` of the entry it receives, so what is sent is the
 * `id` of F = the entry of the SAME key immediately more recent than E (2.4 order: most recent first).
 *
 * @param {object} entry E.
 * @param {object[]} entries the whole list of the language, most recent first (2.4); F is looked up among the
 *   entries of E's key only, never the line above E in a list that mixes keys.
 * @param {string} currentValue the key's value in `terms`; `''` = absent (inherited).
 * @param {boolean} readOnly file not readable (RN25): never a button.
 * @returns {{available: boolean, changeId: number}} `changeId` is F's id; meaningless when not `available`.
 */
export const goBackTarget = (entry, entries = [], currentValue = '', readOnly = false) => {
  const none = { available: false, changeId: 0 }
  if (readOnly) return none
  // The state is already the key's value: nothing to go back to.
  if ((entry.newValue === null ? '' : entry.newValue) === currentValue) return none
  const ofKey = entries.filter((candidate) => candidate.key === entry.key)
  const position = ofKey.findIndex((candidate) => candidate.id === entry.id)
  // The most recent entry of the key has no F.
  if (position < 1) return none
  const following = ofKey[position - 1]
  // Guard: never put back a value other than the one the entry shows, character by character.
  if (following.previousValue !== entry.newValue) return none
  return { available: true, changeId: following.id }
}
